import React, { useState } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-final-form";
import Grid from "@mui/material/Grid";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { Box } from "@mui/material";
import UiInput from "../../../_uiComponents/UiInput";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import Validator from "../../../../_helpers/validate.schema";
import { AuthWrapper } from "../../../_uiComponents/common/AuthWrapper";
import {
     forgotPasswordEmailVeryficationRequest,
     forgotPasswordResetPasswordRequest,
} from "../../../../_redux/_actions";
import { getFingerPrint } from "../../../../_helpers/support.services";

const validateSchema = () =>
     yup.object().shape({
          newPassword: yup
               .string()
               .min(8, "New password must be at least 8 characters long.")
               .matches(
                    /[^\w\s]/,
                    "New password must contain at least one special character.",
               )
               .matches(
                    /[A-Z]/,
                    "New password must contain at least one uppercase letter.",
               )
               .matches(
                    /[a-z]/,
                    "New password must contain at least one lowercase letter.",
               )
               .matches(
                    /[0-9]/,
                    "New password must contain at least one number.",
               )
               .required("New password is required."),
          confirmPassword: yup
               .string()
               .oneOf(
                    [yup.ref("newPassword")],
                    "Confirm password should be equal to new password.",
               )
               .required("Confirm password is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function ResetPassword(props) {
     const Minimum = true;

     const actionDispatch = useDispatch();

     const navigate = useNavigate();

     const [payload, setPayload] = useState({});
     const [newPassword, setNewPassword] = useState("");
     const [confirmPassword, setConfirmPassword] = useState("");

     const urlParams = new URLSearchParams(window.location.search);
     const userId = urlParams.get("user_id");
     const authToken = urlParams.get("auth_token");
     const resetType = urlParams.get("type");

     const haMinimumEightCharacters = newPassword.length >= 8;
     const hasSpecialCharacters = /[^\w\s]/.test(newPassword);
     const hasUpperCaseCharacters = newPassword && /[A-Z]/.test(newPassword);
     const hasLowerCaseCharacters = newPassword && /[a-z]/.test(newPassword);
     const hasNumericCaseCharacters = newPassword && /[0-9]/.test(newPassword);

     const submit = async (values, form) => {
          const browserFingerprint = await getFingerPrint();

          actionDispatch(
               forgotPasswordResetPasswordRequest({
                    ...values,
                    authToken,
                    userId,
                    form,
                    validateOtp: false,
                    browserFingerprint,
                    navigate,
               }),
          );
     };

     return (
          <>
               <AuthWrapper heading="Reset Password">
                    <Box component="div" sx={{ width: "100%" }}>
                         <Form
                              onSubmit={submit}
                              validate={onValidate}
                              render={({
                                   handleSubmit,
                                   hasValidationErrors,
                                   valid,
                                   ...rest
                              }) => {
                                   return (
                                        <form onSubmit={validateSchema}>
                                             <UiInput
                                                  type="password"
                                                  label="New Password"
                                                  name="newPassword"
                                                //   onChange={(e) => {
                                                //        setNewPassword(
                                                //             e.target.value,
                                                //        );
                                                //   }}
                                             />
                                             <div className="sba-password-restrictions">
                                                  <ul>
                                                       <li>
                                                            <CheckOutlinedIcon
                                                                //  style={
                                                                //       haMinimumEightCharacters && {
                                                                //            color: "green",
                                                                //       }
                                                                //  }
                                                            />{" "}
                                                            Minimum 8 Characters
                                                       </li>
                                                       <li>
                                                            <CheckOutlinedIcon
                                                                //  style={
                                                                //       hasSpecialCharacters && {
                                                                //            color: "green",
                                                                //       }
                                                                //  }
                                                            />{" "}
                                                            Special Characters
                                                       </li>
                                                       <li>
                                                            <CheckOutlinedIcon
                                                                //  style={
                                                                //       hasUpperCaseCharacters && {
                                                                //            color: "green",
                                                                //       }
                                                                //  }
                                                            />{" "}
                                                            Uppercase Characters
                                                       </li>
                                                       <li>
                                                            <CheckOutlinedIcon
                                                                //  style={
                                                                //       hasLowerCaseCharacters && {
                                                                //            color: "green",
                                                                //       }
                                                                //  }
                                                            />{" "}
                                                            Lowercase Characters
                                                       </li>
                                                       <li>
                                                            <CheckOutlinedIcon
                                                                //  style={
                                                                //       hasNumericCaseCharacters && {
                                                                //            color: "green",
                                                                //       }
                                                                //  }
                                                            />{" "}
                                                            Numeric Characters
                                                       </li>
                                                  </ul>
                                             </div>
                                             <UiInput
                                                  type="password"
                                                  label="Confirm New Password"
                                                  name="confirmPassword"
                                             />

                                             <Grid container sx={{ mb: 1.3 }}>
                                                  <Grid
                                                       item
                                                       xs
                                                       sx={{
                                                            textAlign: "right",
                                                       }}
                                                  >
                                                       <UiButton
                                                            name="Next"
                                                            variant="contained"
                                                            size="large"
                                                            onClick={
                                                                 handleSubmit
                                                            }
                                                       />
                                                  </Grid>
                                             </Grid>
                                             <p className="sba-login-bottom-support-mail">
                                                  Please reach{" "}
                                                  <span>
                                                       support@sherbetrewards.com{" "}
                                                  </span>
                                                  for further queries
                                             </p>
                                        </form>
                                   );
                              }}
                         />
                    </Box>
               </AuthWrapper>
          </>
     );
}
